import {View} from 'MWC';
import tpl from './transfersToCard.d';
import tplMob from './transfersToCard.m';

export default class extends View {
    template = tpl;
    templateMobile = tplMob;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };
    }

    static displayName = 'Cards.Views.TransfersToCard';
}
